const WA = "https://wa.me/917995495312?text=Hi%20Aria";

const PLANS = [
  {
    key: "starter",
    name: "Starter",
    tagline: "Your AI receptionist.",
    amount: "6,000",
    period: "per month · no setup fee",
    cta: "Get started",
    ctaClass: "btn btn-outline-g",
    features: [
      "24/7 WhatsApp AI bot",
      "FAQ + lead capture automation",
      "Telugu · Hindi · English",
      "Automated lead follow-up",
      "Monthly performance report",
    ],
    featured: false,
  },
  {
    key: "growth",
    name: "Growth",
    tagline: "Your AI business oracle.",
    amount: "15,000",
    period: "per month · no setup fee",
    cta: "Get started",
    ctaClass: "btn btn-gold",
    features: [
      "Everything in Starter",
      "Predictive AI — dropout · no-show · churn",
      "Customer memory + personalisation",
      "Re-engagement automation",
      "Business health dashboard",
      "10-year growth tracking",
      "Priority support",
    ],
    featured: true,
    badge: "Most loved",
  },
  {
    key: "enterprise",
    name: "Enterprise",
    tagline: "Full AI transformation suite.",
    amount: "Custom",
    period: "tailored to your scale",
    cta: "Talk to us",
    ctaClass: "btn btn-outline-g",
    custom: true,
    features: [
      "Everything in Growth",
      "Multi-location · multi-language",
      "ERP & software integrations",
      "Dedicated AI consultant",
      "Staff training included",
      "Custom SLA",
    ],
    featured: false,
  },
];

const Pricing = () => (
  <section id="pricing" className="section bg-grey" data-bg="grey" data-testid="pricing-section">
    <div className="section-inner">
      <div className="reveal">
        <span className="eyebrow">Pricing</span>
        <h2 className="section-h2">
          Simple pricing.<br />
          <span className="serif">No surprises.</span>
        </h2>
        <p className="section-sub">
          Most clients recover their monthly fee in the first week — from leads
          they were quietly losing every day.
        </p>
      </div>

      <div className="price-grid">
        {PLANS.map((p) => (
          <div
            key={p.key}
            className={`price-card reveal ${p.featured ? "featured" : ""}`}
            data-testid={`price-${p.key}`}
          >
            {p.featured && <div className="price-badge">{p.badge}</div>}
            <h3 className="price-name">{p.name}</h3>
            <p className="price-tagline">{p.tagline}</p>
            {p.custom ? (
              <div className="price-amount">{p.amount}</div>
            ) : (
              <div className="price-amount">
                <span className="currency">₹</span>{p.amount}
              </div>
            )}
            <div className="price-period">{p.period}</div>
            <ul className="price-features">
              {p.features.map((f, i) => <li key={i}>{f}</li>)}
            </ul>
            <a
              href={WA}
              target="_blank"
              rel="noreferrer"
              className={p.ctaClass}
              data-testid={`price-cta-${p.key}`}
            >
              {p.cta} →
            </a>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Pricing;
